/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import {
  approveLeave,
  fetchCalendarLeaveData,
  fetchTeamLeavesData,
  fetchTimeLogUsersList,
  rejectLeave,
} from "./fetchData";
import { ProgressSpinner } from "primereact/progressspinner";
import { DataTable, DataTableRowToggleEvent } from "primereact/datatable";
import {
  accordianHeaderTemplate,
  dateBodyTemplate,
  descriptionBodyTemplate,
  emptyMessageTemplate,
  statusBodyTemplateTeamLeaves,
  tableHeaderTemplate,
  totalLeavesBodyTemplate,
} from "../LeavesTemplates";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { Dialog } from "primereact/dialog";
import {
  LEAVE_DAY_TYPES,
  LEAVE_HALF_DAY_TYPES,
  LEAVE_TYPES,
} from "../../../../../util/constants";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { showError } from "../../../../../util/ShowStatus";
import axios from "../../../../../util/axiosconfig";
import { getErrorMessage } from "../../../../../helper/getResponseMessage";
import FullCalendarComponent from "../../Calendar View/FullCalendar";
import { ROLES } from "../../../../../util/roleNameConstants";

const TeamLeaves = ({
  isAddLeaveDialogVisible,
  setIsAddLeaveDialogVisible,
  formValues,
  setFormValues,
  filters,
  leaveTypes,
  activeView,
  setActiveView,
  isViewLeaveData,
  setIsViewLeaveData,
}: any) => {
  const toast = useRef<Toast>(null);
  const [teamLeavesDataLoading, setTeamLeavesDataLoading] =
    useState<boolean>(false);
  const [calendarLeaveDataLoading, setCalendarLeaveDataLoading] =
    useState<boolean>(false);
  const [userDataLoading, setUserDataLoading] = useState<boolean>(false);
  const [isAddButtonDisabled, setIsAddButtonDisabled] =
    useState<boolean>(false);

  const [availableUsedLeaveData, setAvailableUsedLeaveData] = useState<any>({
    availableLeaves: null,
    usedLeaves: null,
    pendingLeaves: null,
    holidayCount: null,
  }); // To hold available and used leave data

  const [showManagerComments, setShowManagerComments] =
    useState<boolean>(false);

  const [teamLeavesData, setTeamLeavesData] = useState<any[]>([]);
  const [showMaxAllowedDatesError, setShowMaxAllowedDatesError] =
    useState<boolean>(false);

  const [hideComments, setHideComments] = useState<boolean>(false);

  const [expandedRows, setExpandedRows] = useState<any>([]);
  const [sortFilter, setSortFilter] = useState<any>({
    sortField: "createdDate",
    sortOrder: true,
  });
  const [timeLogUsersList, setTimeLogUsersList] = useState<any>([]);
  const [selectedDates, setSelectedDates] = useState<any>([]); // To hold selected dates for the date range picker
  const [isApproveReject, setIsApproveReject] = useState<boolean>(false);
  const [managerComments, setManagerComments] = useState<string | null>(null);
  const [approveRejectComments, setApproveRejectComments] = useState<
    string | null
  >(null);
  const [showManagerCommentsError, setShowManagerCommentsError] =
    useState<boolean>(false);
  const [approveRejectViewType, setApproveRejectViewType] =
    useState<string>("approve");
  const [leaveHistoryID, setLeaveHistoryID] = useState<string | null>(null);
  const [approveRejectLoading, setApproveRejectLoading] =
    useState<boolean>(false);

  const [calendarLeaveData, setCalendarLeaveData] = useState<any>([]);

  const [formErrors, setFormErrors] = useState<any>({
    user: null,
    leaveType: null,
    startDate: null,
    endDate: null,
    leaveDayType: null,
    departments: null,
    description: null,
  });

  // const [activeView, setActiveView] = useState<"calendar" | "list">("calendar");

  useEffect(() => {
    setSelectedDates([]);
    setFormValues((prev: any) => ({
      ...prev,
      leaveType: null,
      startDate: null,
      endDate: null,
      totalLeaveDays: null,
      leaveDayType: LEAVE_DAY_TYPES.FULL_DAY,
      halfDayPeriod: LEAVE_HALF_DAY_TYPES.AM, // Add this
      departments: null,
    }));
  }, [formValues?.user]);

  useEffect(() => {
    setSelectedDates([]);
    setFormValues((prev: any) => ({
      ...prev,
      startDate: null,
      endDate: null,
      totalLeaveDays: null,
      leaveDayType: LEAVE_DAY_TYPES.FULL_DAY,
      halfDayPeriod: LEAVE_HALF_DAY_TYPES.AM, // Add this
      departments: null,
    }));
  }, [formValues?.leaveType]);

  const fetchUserLeavesData = async (userID: string) => {
    try {
      setUserDataLoading(true);
      const response = await axios.get(
        `tl-user-leave/my-leave?userID=${userID}`
      );
      setAvailableUsedLeaveData({
        availableLeaves: response.data.available_leaves,
        usedLeaves: response.data.used_leaves,
        pendingLeaves: response.data.pending_leave,
        holidayCount: response.data.holiday_count,
      });
      setUserDataLoading(false);
    } catch (err) {
      const error = getErrorMessage(err);
      setUserDataLoading(false);
      showError(error, toast);
    }
  };

  useEffect(() => {
    fetchTimeLogUsersList(setTimeLogUsersList, toast);
  }, []);

  useEffect(() => {
    fetchTeamLeavesData(
      setTeamLeavesData,
      setTeamLeavesDataLoading,
      // setCalendarLeaveDataLoading,
      filters,
      sortFilter,
      toast
    );
    fetchCalendarLeaveData(
      setCalendarLeaveData,
      setCalendarLeaveDataLoading,
      filters,
      toast
    );
  }, [
    sortFilter,
    filters?.startDate,
    filters?.endDate,
    filters?.leaveType,
    filters?.status,
    filters?.user?.userID,
  ]);

  const InvoiceDateConst = (date: (Date | null)[]): void => {
    setShowMaxAllowedDatesError(false);
    const leaveType = leaveTypes.find(
      (lt: any) => lt.leaveType === formValues.leaveType?.leaveType
    );
    // Calculate max allowed leave days
    const availableLeaves = availableUsedLeaveData.availableLeaves ?? 0;
    const pendingLeaves = availableUsedLeaveData.pendingLeaves ?? 0;
    const maxAllowedLeaveDays = availableLeaves - pendingLeaves;

    // Convert to UTC timestamp (seconds)
    const formattedStartDate = date[0]
      ? Math.floor(
          Date.UTC(
            date[0].getFullYear(),
            date[0].getMonth(),
            date[0].getDate(),
            0,
            0,
            0,
            0
          ) / 1000.0
        )
      : null;
    const formattedEndDate = date[1]
      ? Math.floor(
          Date.UTC(
            date[1].getFullYear(),
            date[1].getMonth(),
            date[1].getDate(),
            0,
            0,
            0,
            0
          ) / 1000.0
        )
      : null;

    const calculateBusinessDays = (startDate: Date, endDate: Date): number => {
      let count = 0;
      let currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        const day = currentDate.getDay();
        if (day !== 0 && day !== 6) {
          // Skip Sundays (0) and Saturdays (6)
          count++;
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return count;
    };

    if (formValues.leaveDayType === LEAVE_DAY_TYPES.HALF_DAY) {
      if (formattedStartDate) {
        // For half day, total leave days is always 0.5
        const newTotalLeaveDays = 0.5;

        if (newTotalLeaveDays > maxAllowedLeaveDays) {
          if (
            leaveType &&
            // (leaveType.leaveType === LEAVE_TYPES.ABSCENCE_LEAVE ||
            //   leaveType.leaveType === LEAVE_TYPES.SICK_LEAVE)
            leaveType.leaveType === LEAVE_TYPES.SICK_LEAVE
          ) {
            setFormValues((prev: any) => ({
              ...prev,
              startDate: formattedStartDate,
              endDate: formattedStartDate,
              totalLeaveDays: newTotalLeaveDays,
            }));
            return;
          } else {
            setFormErrors((prev: any) => ({
              ...prev,
              totalLeaveDays: `Total leave days cannot exceed ${maxAllowedLeaveDays} days`,
            }));
            setShowMaxAllowedDatesError(true);
            setSelectedDates([]); // Reset dates when limit exceeded
            setFormValues((prev: any) => ({
              ...prev,
              startDate: null,
              endDate: null,
              totalLeaveDays: null,
            }));
            return;
          }
        } else {
          setFormErrors((prev: any) => ({
            ...prev,
            totalLeaveDays: null,
          }));
        }
        setSelectedDates([date[0], date[0]]);
        setFormValues((prev: any) => ({
          ...prev,
          startDate: formattedStartDate,
          endDate: formattedStartDate,
          totalLeaveDays: newTotalLeaveDays,
        }));
      }
    } else {
      if (formattedStartDate && formattedEndDate) {
        const startDate = new Date(formattedStartDate * 1000);
        const endDate = new Date(formattedEndDate * 1000);
        const differenceInDays = calculateBusinessDays(startDate, endDate);

        if (differenceInDays > maxAllowedLeaveDays) {
          if (leaveType && leaveType.leaveType === LEAVE_TYPES.SICK_LEAVE) {
            setFormValues((prev: any) => ({
              ...prev,
              startDate: formattedStartDate,
              endDate: formattedEndDate,
              totalLeaveDays: differenceInDays,
            }));
            return;
          } else {
            setShowMaxAllowedDatesError(true);
            setFormErrors((prev: any) => ({
              ...prev,
              totalLeaveDays: `Total leave days cannot exceed ${maxAllowedLeaveDays} days`,
            }));
            setSelectedDates([]); // Reset dates when limit exceeded
            setFormValues((prev: any) => ({
              ...prev,
              startDate: null,
              endDate: null,
              totalLeaveDays: null,
            }));
            return;
          }
        } else {
          setFormErrors((prev: any) => ({
            ...prev,
            totalLeaveDays: null,
          }));
        }
        setFormValues((prev: any) => ({
          ...prev,
          totalLeaveDays: differenceInDays,
        }));
      }
      setSelectedDates(date);
      setFormValues((prev: any) => ({
        ...prev,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      }));
    }
  };

  const validateForm = () => {
    const errors: Partial<Record<string, string>> = {};

    if (!formValues.user) {
      errors.user = "User is required";
    }

    if (!formValues.leaveType) {
      errors.leaveType = "Leave type is required";
    }
    if (!formValues.startDate) {
      errors.startDate = "Start date is required";
    }
    if (!formValues.endDate) {
      errors.endDate = "End date is required";
    }
    if (!formValues.leaveDayType) {
      errors.leaveDayType = "Leave day type is required";
    }
    if (
      formValues?.leaveDayType === LEAVE_DAY_TYPES.HALF_DAY &&
      !formValues.halfDayPeriod
    ) {
      errors.halfDayPeriod = "Half day period is required";
    }
    if (formValues.startDate && formValues.endDate) {
      const startDate = new Date(formValues.startDate * 1000);
      const endDate = new Date(formValues.endDate * 1000);
      if (startDate > endDate) {
        errors.startDate = "Start date cannot be after end date";
        errors.endDate = "End date cannot be before start date";
      }
    }
    if (formValues.totalLeaveDays && formValues.totalLeaveDays < 0) {
      errors.totalLeaveDays = "Total leave days cannot be negative";
    }
    // if (!formValues.departments || formValues.departments.length === 0) {
    //   errors.departments = "Department is required";
    // }
    if (!formValues.description || formValues.description.trim() === "") {
      errors.description = "Description is required";
    }
    // if (formValues.totalLeaveDays && formValues.totalLeaveDays > 30) {
    //   errors.totalLeaveDays = "Total leave days cannot exceed 30 days";
    // }
    // if (formValues.leaveDayType === LEAVE_DAY_TYPES.HALF_DAY && formValues.totalLeaveDays > 1) {
    //   errors.totalLeaveDays = "Total leave days cannot exceed 1 day for Half Day";
    // }
    // if (formValues.leaveType === "Sick Leave" && formValues.totalLeaveDays > 3) {
    //   errors.totalLeaveDays = "Total leave days cannot exceed 3 days for Sick Leave";
    // }
    // if (formValues.leaveType === "Annual Leave" && formValues.totalLeaveDays > 30) {
    //   errors.totalLeaveDays = "Total leave days cannot exceed 30 days for Annual Leave";
    // }
    // if (formValues.leaveType === "Casual Leave" && formValues.totalLeaveDays > 5) {
    //   errors.totalLeaveDays = "Total leave days cannot exceed 5 days for Casual Leave";
    // }
    setFormErrors((prev: any) => ({ ...prev, ...errors }));

    return Object.keys(errors).length === 0; // Returns true if no errors
  };

  const handleAddUpdateMyLeaves = async () => {
    if (!validateForm()) return; // Stop submission if validation fails
    const params: any = {};
    try {
      if (formValues.user) params.userID = formValues.user.userID;
      if (formValues.leaveType) params.leaveTypeID = formValues.leaveType.id;
      if (formValues.startDate) params.startDate = formValues.startDate;
      if (formValues.endDate) params.endDate = formValues.endDate;
      if (formValues.totalLeaveDays)
        params.totalLeaveDays = formValues.totalLeaveDays;
      if (formValues.leaveDayType)
        params.leaveDayType = formValues.leaveDayType;
      if (
        formValues.halfDayPeriod &&
        formValues.leaveDayType === LEAVE_DAY_TYPES.HALF_DAY
      )
        params.dayPart = formValues.halfDayPeriod;
      // if(formValues.departments) params.departmentID = formValues.departments.map((item: any) => item.departmentID).join(",")
      if (formValues.description) params.description = formValues.description;

      setIsAddButtonDisabled(true);
      await axios.post("tl-user-leave/add-leave", params);
      setFormValues({
        user: null,
        leaveType: null,
        startDate: null,
        endDate: null,
        totalLeaveDays: null,
        leaveDayType: LEAVE_DAY_TYPES.FULL_DAY,
        departments: null,
        description: null,
      });
      setSelectedDates([]);
      setFormErrors({
        user: null,
        leaveType: null,
        startDate: null,
        endDate: null,
        leaveDayType: null,
        departments: null,
        description: null,
      });
      fetchTeamLeavesData(
        setTeamLeavesData,
        setTeamLeavesDataLoading,
        // setCalendarLeaveDataLoading,
        filters,
        sortFilter,
        toast
      );
      fetchCalendarLeaveData(
        setCalendarLeaveData,
        setCalendarLeaveDataLoading,
        filters,
        toast
      );
      fetchTimeLogUsersList(setTimeLogUsersList, toast);
      setIsAddButtonDisabled(false);
      setIsAddLeaveDialogVisible(false);
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
      setIsAddButtonDisabled(false);
    }
  };

  return (
    <>
      <div>
        {/* Tab Switcher */}
        <div className="tw-flex tw-border-b tw-mb-4">
          <button
            className={`tw-px-4 tw-py-2 tw-font-semibold tw-border-b-2 ${
              activeView === "calendar"
                ? "tw-border-[#152846] tw-text-[#152846] tw-bg-[#F4F6FF]"
                : "tw-border-transparent tw-text-gray-500"
            }`}
            //tw-bg-[#F4F6FF] tw-bg-[#E8F9FF]
            onClick={() => setActiveView("calendar")}
          >
            Calendar view
          </button>
          <button
            className={`tw-px-4 tw-py-2 tw-font-semibold tw-border-b-2 ${
              activeView === "list"
                ? "tw-border-[#152846] tw-text-[#152846] tw-bg-[#F4F6FF]"
                : "tw-border-transparent tw-text-gray-500"
            }`}
            onClick={() => setActiveView("list")}
          >
            List view
          </button>
        </div>
        {/* Tab Content */}
        {activeView === "calendar" ? (
          <div className="tw-p tw-text-center tw-text-lg tw-text-gray-500">
            <FullCalendarComponent
              isAddLeaveDialogVisible={isAddLeaveDialogVisible}
              setIsAddLeaveDialogVisible={setIsAddLeaveDialogVisible}
              formValues={formValues}
              setFormValues={setFormValues}
              filters={filters}
              leaveTypes={leaveTypes}
              setSelectedDates={setSelectedDates}
              calendarLeaveDataLoading={calendarLeaveDataLoading}
              setCalendarLeaveDataLoading={setCalendarLeaveDataLoading}
              calendarLeaveData={calendarLeaveData}
              setCalendarLeaveData={setCalendarLeaveData}
              setLeaveHistoryID={setLeaveHistoryID}
              setIsApproveReject={setIsApproveReject}
              setApproveRejectViewType={setApproveRejectViewType}
              isViewLeaveData={isViewLeaveData}
              setIsViewLeaveData={setIsViewLeaveData}
              // toast
            />
          </div>
        ) : teamLeavesDataLoading ? (
          <div className="tw-h-full tw-w-full tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
            <ProgressSpinner />
          </div>
        ) : (
          <div className="card">
            <DataTable
              value={teamLeavesData}
              rowGroupMode="subheader"
              groupRowsBy="displayName"
              sortMode="single"
              expandableRowGroups
              expandedRows={expandedRows}
              emptyMessage={emptyMessageTemplate}
              onRowToggle={(e: DataTableRowToggleEvent) => {
                setExpandedRows(e.data);
              }}
              rowGroupHeaderTemplate={(e) => accordianHeaderTemplate(e)}
              tableStyle={{ minWidth: "50rem" }}
              className="a-table timelog-datatable tw-text-nowrap tw-text-sm tw-text-[#64748B]"
              rowClassName={(rowData: any) =>
                rowData.isLogTimeMisMatch === 1 ? "error-row" : ""
              }
            >
              <Column
                field="startDate"
                header={tableHeaderTemplate(
                  "Start Date",
                  "startDate",
                  setSortFilter
                )}
                body={(e) => dateBodyTemplate(e, "startDate")}
              ></Column>
              <Column
                field="endDate"
                header={tableHeaderTemplate(
                  "End Date",
                  "endDate",
                  setSortFilter
                )}
                body={(e) => dateBodyTemplate(e, "endDate")}
              ></Column>
              <Column
                field="totalLeaves"
                header={tableHeaderTemplate(
                  "Total Leaves Days",
                  "totalLeaveDays",
                  setSortFilter
                )}
                body={totalLeavesBodyTemplate}
              ></Column>
              <Column
                field="leaveTypeID"
                header={tableHeaderTemplate(
                  "Type",
                  "leaveTypeID",
                  setSortFilter
                )}
                body={(e) => {
                  return <span className="">{e.tLLeaveType.leaveType}</span>;
                }}
              ></Column>
              <Column
                field="description"
                header={tableHeaderTemplate(
                  "Description",
                  "description",
                  setSortFilter
                )}
                body={descriptionBodyTemplate}
              ></Column>
              <Column
                field="status"
                header={tableHeaderTemplate("Status", "status", setSortFilter)}
                body={(e: any) =>
                  statusBodyTemplateTeamLeaves(
                    e,
                    setLeaveHistoryID,
                    setIsApproveReject,
                    setApproveRejectViewType,
                    setShowManagerComments,
                    setApproveRejectComments
                  )
                }
              ></Column>
            </DataTable>
          </div>
        )}
      </div>
      {/* Add Leave Dialog */}
      <Dialog
        header={"Add Leave"}
        visible={isAddLeaveDialogVisible}
        style={{ width: "24vw" }}
        onHide={() => {
          setFormValues({
            user: null,
            leaveType: null,
            startDate: null,
            endDate: null,
            totalLeaveDays: null,
            leaveDayType: LEAVE_DAY_TYPES.FULL_DAY,
            departments: null,
            description: null,
          });
          setFormErrors({
            user: null,
            leaveType: null,
            startDate: null,
            endDate: null,
            leaveDayType: null,
            departments: null,
            description: null,
          });
          setSelectedDates([]);
          setIsAddLeaveDialogVisible(false);
        }}
      >
        <div className="tw-flex tw-flex-col tw-gap-4">
          <div className="tw-flex tw-flex-col tw-gap-2">
            <label className="tw-font-medium">User</label>
            <Dropdown
              value={formValues.user ?? ""}
              options={timeLogUsersList}
              onChange={(e) => {
                fetchUserLeavesData(e.value.userID);
                setFormErrors((prev: any) => ({
                  ...prev,
                  user: null,
                }));
                setFormValues((prev: any) => ({
                  ...prev,
                  user: e.value,
                }));
              }}
              loading={userDataLoading}
              filter
              optionLabel="displayName"
              placeholder="Select a user"
              className={`tw-border tw-border-solid ${
                formErrors.user ? "tw-border-red-600" : "tw-border-gray-400"
              } tw-rounded-md placeholder:tw-font-normal tw-w-full`}
            />
          </div>
          <div className="tw-flex tw-flex-col tw-gap-2">
            <label className="tw-font-medium">Leave Type</label>
            <Dropdown
              value={formValues.leaveType ?? ""}
              options={leaveTypes}
              onChange={(e) => {
                setFormErrors((prev: any) => ({
                  ...prev,
                  leaveType: null,
                }));
                setFormValues((prev: any) => ({
                  ...prev,
                  leaveType: e.value,
                }));
              }}
              optionLabel="leaveType"
              placeholder="Select Leave Type"
              className={`tw-border tw-border-solid ${
                formErrors.leaveType
                  ? "tw-border-red-600"
                  : "tw-border-gray-400"
              } tw-rounded-md placeholder:tw-font-normal tw-w-full`}
            />
          </div>

          <div className="tw-flex tw-flex-col tw-gap-2">
            <label className="tw-font-medium">Select Date Range</label>
            <Calendar
              value={selectedDates ?? []}
              dateFormat="dd-mm-yy"
              onChange={(e) => {
                e.stopPropagation();
                setFormErrors((prev: any) => ({
                  ...prev,
                  startDate: null,
                  endDate: null,
                  totalLeaveDays: null,
                }));
                const selectedDates = e.value as (Date | null)[];
                InvoiceDateConst(selectedDates);
              }}
              selectionMode="range"
              // Disable Sundays and Saturdays
              className={`${
                formErrors.startDate ||
                formErrors.endDate ||
                formErrors.totalLeaveDays
                  ? "tw-border-red-600"
                  : "tw-border-gray-400"
              } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
              placeholder="Select Date Range"
              showIcon
              readOnlyInput
              hideOnRangeSelection
              minDate={
                localStorage.roleName &&
                localStorage.roleName.includes(ROLES.TIMELOG_ADMIN)
                  ? undefined
                  : formValues.leaveType?.leaveType === LEAVE_TYPES.SICK_LEAVE
                  ? // || formValues.leaveType?.leaveType === LEAVE_TYPES.ABSCENCE_LEAVE
                    (() => {
                      const today = new Date();
                      const firstOfMonth = new Date(
                        today.getFullYear(),
                        today.getMonth(),
                        1
                      );
                      const sevenDaysAgo = new Date(today);
                      sevenDaysAgo.setDate(today.getDate() - 7);
                      return sevenDaysAgo < firstOfMonth
                        ? firstOfMonth
                        : sevenDaysAgo;
                    })()
                  : new Date(new Date().getFullYear(), new Date().getMonth(), 1)
              } // Set min date to the 1st of the current month
              maxDate={
                localStorage.roleName &&
                localStorage.roleName.includes(ROLES.TIMELOG_ADMIN)
                  ? undefined
                  : formValues.leaveType?.leaveType === LEAVE_TYPES.SICK_LEAVE
                  ? // || formValues.leaveType?.leaveType === LEAVE_TYPES.ABSCENCE_LEAVE
                    new Date()
                  : undefined
              }
            />
            {showMaxAllowedDatesError && (
              <p className="tw-text-red-600 tw-text-sm tw-mt-1">
                {formErrors?.totalLeaveDays}
              </p>
            )}
          </div>

          <div className="tw-flex tw-flex-col tw-gap-2">
            <label className="tw-font-medium">Day Type</label>
            <div className="tw-flex tw-bg-white tw-border tw-border-gray-400 tw-rounded-full tw-p- tw-w-full">
              <button
                type="button"
                className={`tw-flex-1 tw-py-2 tw-rounded-full tw-rounded-r-none tw-border-r-gray-400 tw-text-sm tw-font-medium ${
                  formValues.leaveDayType === LEAVE_DAY_TYPES.FULL_DAY
                    ? "tw-bg-[#e0f7ff] tw-text-black tw-border tw-border-[#bae6fd]"
                    : "tw-bg-white tw-text-gray-700"
                }`}
                onClick={() =>
                  setFormValues((prev: any) => ({
                    ...prev,
                    totalLeaveDays: 1,
                    leaveDayType: LEAVE_DAY_TYPES.FULL_DAY,
                  }))
                }
              >
                {formValues.leaveDayType === LEAVE_DAY_TYPES.FULL_DAY && `✓`}{" "}
                {LEAVE_DAY_TYPES.FULL_DAY}
              </button>
              <button
                type="button"
                className={`tw-flex-1 tw-py-2 tw-rounded-full tw-rounded-l-none tw-border-l-gray-400 tw-text-sm tw-font-medium ${
                  formValues.leaveDayType === LEAVE_DAY_TYPES.HALF_DAY
                    ? "tw-bg-[#e0f7ff] tw-text-black tw-border tw-border-[#bae6fd]"
                    : "tw-bg-white tw-text-gray-700"
                }`}
                onClick={() => {
                  if (formValues.totalLeaveDays > 1) {
                    setFormErrors((prev: any) => ({
                      ...prev,
                      totalLeaveDays:
                        "Total leave days cannot exceed 1 day for Half Day",
                    }));
                    showError(
                      "Total leave days cannot exceed 1 day for Half Day",
                      toast
                    );
                    return;
                  }
                  setFormValues((prev: any) => ({
                    ...prev,
                    totalLeaveDays: 0.5,
                    leaveDayType: LEAVE_DAY_TYPES.HALF_DAY,
                  }));
                }}
              >
                {formValues.leaveDayType === LEAVE_DAY_TYPES.HALF_DAY && `✓`}{" "}
                {LEAVE_DAY_TYPES.HALF_DAY}
              </button>
            </div>
            {/* Add AM/PM selection when half-day is chosen */}
            {formValues.leaveDayType === LEAVE_DAY_TYPES.HALF_DAY && (
              <div className="tw-flex tw-flex-col tw-gap-2 tw-mt-2">
                <label className="tw-font-medium">Half Day Period</label>
                <div
                  className={`${
                    formErrors.halfDayPeriod
                      ? "tw-border-red-600"
                      : "tw-border-gray-400"
                  } tw-flex tw-bg-white tw-border tw-border-gray-400 tw-rounded-full tw-p- tw-w-full`}
                >
                  <button
                    type="button"
                    className={`tw-flex-1 tw-py-2 tw-rounded-full tw-rounded-r-none tw-border-r-gray-400 tw-text-sm tw-font-medium ${
                      formValues.halfDayPeriod === LEAVE_HALF_DAY_TYPES.AM
                        ? "tw-bg-[#e0f7ff] tw-text-black tw-border tw-border-[#bae6fd]"
                        : "tw-bg-white tw-text-gray-700"
                    }`}
                    onClick={() => {
                      setFormErrors((prev: any) => ({
                        ...prev,
                        halfDayPeriod: null,
                      }));
                      setFormValues((prev: any) => ({
                        ...prev,
                        halfDayPeriod: LEAVE_HALF_DAY_TYPES.AM,
                      }));
                    }}
                  >
                    {formValues.halfDayPeriod === LEAVE_HALF_DAY_TYPES.AM &&
                      `✓`}{" "}
                    {LEAVE_HALF_DAY_TYPES.AM}
                  </button>
                  <button
                    type="button"
                    className={`tw-flex-1 tw-py-2 tw-rounded-full tw-rounded-l-none tw-border-l-gray-400 tw-text-sm tw-font-medium ${
                      formValues.halfDayPeriod === LEAVE_HALF_DAY_TYPES.PM
                        ? "tw-bg-[#e0f7ff] tw-text-black tw-border tw-border-[#bae6fd]"
                        : "tw-bg-white tw-text-gray-700"
                    }`}
                    onClick={() => {
                      setFormErrors((prev: any) => ({
                        ...prev,
                        halfDayPeriod: null,
                      }));
                      setFormValues((prev: any) => ({
                        ...prev,
                        halfDayPeriod: LEAVE_HALF_DAY_TYPES.PM,
                      }));
                    }}
                  >
                    {formValues.halfDayPeriod === LEAVE_HALF_DAY_TYPES.PM &&
                      `✓`}{" "}
                    {LEAVE_HALF_DAY_TYPES.PM}
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className="tw-flex tw-flex-col tw-gap-2">
            <label className="tw-font-medium">Description</label>
            <InputTextarea
              value={formValues.description ?? ""}
              onChange={(e) => {
                setFormErrors((prev: any) => ({
                  ...prev,
                  description: null,
                }));
                setFormValues((prev: any) => ({
                  ...prev,
                  description: e.target.value,
                }));
              }}
              rows={3}
              className={`${
                formErrors.description
                  ? "tw-border-red-600"
                  : "tw-border-gray-400"
              } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-400 tw-rounded-md placeholder:tw-font-normal`}
              placeholder="Enter description"
            />
            <Button
              label={"Add Leave"}
              disabled={isAddButtonDisabled}
              className="tw-flex tw-px-3 focus:tw-shadow-none tw-py-2 tw-rounded-lg bg-primary border-primary tw-text-white tw-font-medium tw-w-full tw-mt-8"
              onClick={() => {
                // Handle add leave logic here
                handleAddUpdateMyLeaves();
              }}
            />
          </div>
        </div>
      </Dialog>

      <Dialog
        className="comments-dialog"
        header={`${
          approveRejectViewType === "approve" ? "Approve" : "Reject"
        } Leave`}
        visible={isApproveReject}
        draggable={false}
        style={{ maxWidth: "400px" }}
        onHide={() => {
          if (!isApproveReject) return;
          setIsApproveReject(false);
          setManagerComments(null);
          setShowManagerCommentsError(false);
        }}
      >
        <div className="tw-p-6">
          <InputTextarea
            className={`${
              showManagerCommentsError
                ? "tw-border-red-600"
                : "tw-border-gray-400"
            } `}
            value={managerComments ?? ""}
            onChange={(e) => {
              setShowManagerCommentsError(false);
              setManagerComments(e.target.value);
            }}
            rows={5}
            cols={30}
            placeholder="Add Comment"
          />
          <div className="tw-flex tw-items-center tw-mt-6 tw-text-base">
            <input
              type="checkbox"
              id="hideComment"
              className="tw-mr-2 tw-cursor-pointer tw-w-5 tw-h-4"
              onChange={(e) => {
                setHideComments(e.target.checked);
              }}
            />
            <label
              htmlFor="hideComment"
              className="tw-text-base tw-cursor-pointer tw-text-gray-700"
            >
              Hide comment from the user
            </label>
          </div>
        </div>
        <div className="tw-flex tw-w-full tw-gap-2 tw-pt-6 tw-px-6 tw-pb-6 tw-border-t tw-border-t-solid tw-border-t-[#DBDBDB]">
          <Button
            label={`${
              approveRejectViewType === "approve" ? "Approve" : "Reject"
            }`}
            onClick={() =>
              approveRejectViewType === "approve"
                ? approveLeave(
                    leaveHistoryID,
                    managerComments,
                    setIsApproveReject,
                    setApproveRejectLoading,
                    setManagerComments,
                    hideComments,
                    toast
                  ).then(() => {
                    fetchTeamLeavesData(
                      setTeamLeavesData,
                      setTeamLeavesDataLoading,
                      // setCalendarLeaveDataLoading,
                      filters,
                      sortFilter,
                      toast
                    );
                    fetchCalendarLeaveData(
                      setCalendarLeaveData,
                      setCalendarLeaveDataLoading,
                      filters,
                      toast
                    );
                    setIsViewLeaveData(false);
                    fetchTimeLogUsersList(setTimeLogUsersList, toast);
                  })
                : rejectLeave(
                    leaveHistoryID,
                    managerComments,
                    setIsApproveReject,
                    setApproveRejectLoading,
                    setManagerComments,
                    setShowManagerCommentsError,
                    hideComments,
                    toast
                  ).then(() => {
                    if (!managerComments || managerComments.trim() === "") {
                      return;
                    }

                    fetchTeamLeavesData(
                      setTeamLeavesData,
                      setTeamLeavesDataLoading,
                      // setCalendarLeaveDataLoading,
                      filters,
                      sortFilter,
                      toast
                    );
                    fetchCalendarLeaveData(
                      setCalendarLeaveData,
                      setCalendarLeaveDataLoading,
                      filters,
                      toast
                    );
                    setIsViewLeaveData(false);
                    fetchTimeLogUsersList(setTimeLogUsersList, toast);
                  })
            }
            disabled={approveRejectLoading}
            className={`tw-w-full tw-py-3 tw-bg-[#00AFEE] tw-text-white tw-rounded-lg tw-font-semibold`}
          />
        </div>
      </Dialog>

      <Dialog
        className="comments-dialog"
        header={`Comments`}
        footer={null}
        visible={showManagerComments}
        draggable={false}
        style={{ maxWidth: "400px", minWidth: "300px" }}
        onHide={() => {
          if (!showManagerComments) return;
          setShowManagerComments(false);
        }}
      >
        <div className="tw-p-6">
          <div className="tw-p-4 tw-border-b tw-border-b-solid tw-border-b-[#DBDBDB]">
            <p className="tw-m-0 tw-text-center tw-text-base tw-font-normal tw-text-black">
              {approveRejectComments ?? "No comments added"}
            </p>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default TeamLeaves;
